import $ from "jquery";
import { EEcommerceSystemEnvironment } from "@devowl-wp/api-real-commerce";
import { Subscription } from "./subscription.js";
import { derivePaymentMethodDescriptor } from "../utils/paymentMethodDescriptor.js";
class PaddleSubscription extends Subscription {
    /**
     * @see https://developer.paddle.com/guides/how-tos/checkout/inline-checkout
     */ get Paddle() {
        return this.paddle;
    }
    async loadVendorScripts() {
        await $.getScript("https://cdn.paddle.com/paddle/paddle.js");
        this.paddle = window.Paddle;
        if (this.data.productPlan.product.ecommerceSystem.environment === EEcommerceSystemEnvironment.Sandbox) {
            this.paddle.Environment.set("sandbox");
        }
        this.paddle.Setup({
            vendor: +this.data.productPlan.product.ecommerceSystem.vendorId
        });
    }
    getHumanReadablePaymentMethod() {
        const { paymentMethod } = this.data.paymentInformation ?? {};
        if (paymentMethod === undefined) {
            return "Not set";
        }
        const { label, lastFour, network } = derivePaymentMethodDescriptor(this.data.paymentInformation);
        const suffix = network !== "paypal" && lastFour ? ` (ending with ${lastFour})` : "";
        return `${label}${suffix}`;
    }
}
export { PaddleSubscription };
